<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'export-offers'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHome"></p-breadcrumb>
  <div style="margin-top: 30px">
    <app-order-detail-component [order]="order" [isClosedSale]="true" [directSaleProgramId]="directSaleProgramId" *ngIf="order"></app-order-detail-component>
  </div>
</app-user-dashboard>
